export { default as InsightsView } from "../../Insights/components";
export { default as InsightButtons } from "./InsightButtons/InsightButtons";
export { default as TriggerButton } from "./TriggerButton/TriggerButton";
export { default as InsightsDisabledModal } from "./InsightsDisabledModal";
export { default as PrivateEmbeddedInsight } from "./PrivateEmbeddedInsight/PrivateEmbeddedInsight";
// eslint-disable-next-line max-len
export { InsightsUpgradeModal } from "scenes/Settings/components/HubSettings/components/UserInformationForm/components/InsightsConfirmationModal/components";
